import ErrorAlert from "@/utility/ErrorAlert";
import { isEmpty } from "lodash";
import http from "../axios/http-common";

async function create(data) {
  const response = await http
    .postData("/asesmen-awal-gadar-medis", data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function update(id, data) {
  const response = await http
    .putData(`/asesmen-awal-gadar-medis/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function updatePemulangan(id, data) {
  const response = await http
    .putData(`/asesmen-awal-gadar-medis/${id}/pemulangan`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function signDpjp(id, password: string) {
  const response = await http
    .putData(`/asesmen-awal-gadar-medis/${id}/sign-dpjp`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/asesmen-awal-gadar-medis2`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`/asesmen-awal-gadar-medis2/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/asesmen-awal-gadar-medis/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  const data = isEmpty(response?.data) ? null : response.data;

  return data;
}

export default {
  create,
  update,
  updatePemulangan,
  signDpjp,
  getByRegister,
  find,
  destroy
};
